import { WalletTransactionListItem } from "../../models/Wallet";
import { TableProps } from "./types";
import GenericItemsTable, { DefaultColumnMapper } from "./GenericItemsTable";
import { WhiteLabelFormGenericForm } from "../forms/WhiteLabelForm";
import WalletService from "../../services/crud/WalletService";
import { ColumnType } from "antd/lib/table/interface";
import { formatPointsInCents } from "../../utils/common";
import { Popover, Tooltip, Typography } from "antd";
import { formatDateTime } from "../../utils/dates";

export const GenericWalletTransactionsTable = ({ accountId, ...rest }: TableProps<WalletTransactionListItem> & {accountId: number}) => {
  return (
    <GenericItemsTable
      model={WalletTransactionListItem}
      name={'Transaction'}
      form={null}
      hideActions={true}
      hideButtons={true}
      actions={{}}
      service={WalletService}
      dataLoader={async () => accountId !== null && accountId !== undefined ? await WalletService.getWalletTransactions(accountId) : []}
      defaultPageSize={30}
      defaultRowSorter={(a, b) => {
        if(a.date < b.date) return 1;
        if(a.date > b.date) return -1;
        return 0;
      }}
      columnFilter={(col) => ['id', 'updatedAt', 'actions'].indexOf(`${col.key}`) === -1}
      columnMapper={(col) => {
        col = DefaultColumnMapper(col);
        if (col.key === 'transactionId') {
          col.title = 'ID';
          col.render = (text, record, index) => {
            return (
              <Popover content={text}>
                <span style={{fontFamily: 'consolas, "lucida console"', fontSize: 10}}>{text.slice(0, 5)}..</span>
              </Popover>
          )
          }
        }
        if (col.key === 'actor') {
          col.render = (text, record, index) => {
            const actorType = record.actor.type;
            const actorName = record.actor.name;
            const actorAccountId = record.actor.accountId;
            const actorTspId = record.actor.tspId;
            const content = (
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <Typography.Text><b>Name:</b> {actorName}</Typography.Text>
                <Typography.Text><b>Type:</b> {actorType}</Typography.Text>
                <Typography.Text><b>Account id:</b> {actorAccountId ?? 'null'}</Typography.Text>
                <Typography.Text><b>TSP id:</b> {actorTspId ?? 'null'}</Typography.Text>
              </div>
            )
            return (
              <Popover title="Actor" content={content}>
                <Typography.Text>{actorName}</Typography.Text>
              </Popover>
            );
          }
        }
        if (col.key === 'message') {
          col.render = (text, record, index) => {
            return <Typography.Text style={{whiteSpace: 'pre-wrap'}}>{`${text ?? ''}`}</Typography.Text>;
          }
        }
        if (col.key === 'amountCents') {
          col.title = 'Amount';
          col.render = (text, record, index) => {
            const amountP = formatPointsInCents(record.amountCents, 'short');
            return (<Typography.Text>{`${amountP}`}</Typography.Text>);
          }
        }
        if (col.key === 'date') {
          col.title = 'When'
          col.render = (text, record, index) => {
            return (<Typography.Text>{formatDateTime(record.date)}</Typography.Text>);
          }
        }
        if (col.key === 'expireDatetime') {
          col.title = 'Expires'
          col.render = (text, record, index) => {
            const expired = record.expireDatetime && record.expireDatetime < new Date();
            return (<>
              <Typography.Text>{record.expireDatetime ? formatDateTime(record.expireDatetime) : '-'}</Typography.Text>
              {expired && (
                <Typography.Text style={{color: 'red', whiteSpace: 'pre-wrap'}}>{'\n'}expired</Typography.Text>
              )}
            </>);
          }
        }
        return col;
      }}
      {...rest}
    ></GenericItemsTable>
  );
};